// Static mock data for University Manager demo dashboard
// Field names match the real API models used by the existing admin panel

export const MOCK_UNIVERSITIES = [
  {
    id: 1,
    nameEn: "Istanbul Technical University",
    nameLocal: "İstanbul Teknik Üniversitesi",
    shortName: "ITU",
    countryName: "Turkey",
    cityName: "Istanbul",
    email: "info@itu.edu.tr",
    phone: "+90 212 285 3000",
    website: "https://www.itu.edu.tr",
    address: "Maslak, Istanbul, 34469",
    foundedYear: 1773,
    active: true,
    logoUrl: null,
    descriptionEn: "One of the oldest technical universities in the world.",
    descriptionLocal: "Dünyanın en eski teknik üniversitelerinden biri.",
  },
  {
    id: 2,
    nameEn: "Bogazici University",
    nameLocal: "Boğaziçi Üniversitesi",
    shortName: "BOUN",
    countryName: "Turkey",
    cityName: "Istanbul",
    email: "info@boun.edu.tr",
    phone: "+90 212 359 5400",
    website: "https://www.boun.edu.tr",
    address: "Bebek, Istanbul, 34342",
    foundedYear: 1863,
    active: true,
    logoUrl: null,
    descriptionEn: "A leading research university in Turkey.",
    descriptionLocal: "Türkiye'nin önde gelen araştırma üniversitesi.",
  },
  {
    id: 3,
    nameEn: "Middle East Technical University",
    nameLocal: "Orta Doğu Teknik Üniversitesi",
    shortName: "METU",
    countryName: "Turkey",
    cityName: "Ankara",
    email: "info@metu.edu.tr",
    phone: "+90 312 210 2000",
    website: "https://www.metu.edu.tr",
    address: "Universiteler Mah., Ankara, 06800",
    foundedYear: 1956,
    active: true,
    logoUrl: null,
    descriptionEn: "Premier research and teaching institution in Turkey.",
    descriptionLocal: "Türkiye'nin önde gelen araştırma ve eğitim kurumu.",
  },
  {
    id: 4,
    nameEn: "Mersin University",
    nameLocal: "Mersin Üniversitesi",
    shortName: "MEU",
    countryName: "Turkey",
    cityName: "Istanbul",
    email: "info@MEU.edu.tr",
    phone: "+90 212 400 0000",
    website: "https://www.MEU.edu.tr",
    address: "Levent, Istanbul, 34330",
    foundedYear: 1998,
    active: true,
    logoUrl: null,
    descriptionEn:
      "A modern university focused on innovation and interdisciplinary studies.",
    descriptionLocal:
      "Yenilikçilik ve disiplinlerarası çalışmalara odaklanan modern bir üniversite.",
  },
];

export const MOCK_CAMPUSES = [
  {
    id: 1,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    nameEn: "Maslak Campus",
    nameLocal: "Maslak Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 22000,
    clubCount: 48,
    eventCount: 120,
    createdAt: "2023-01-10T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 2,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    nameEn: "Taskisla Campus",
    nameLocal: "Taşkışla Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 8000,
    clubCount: 18,
    eventCount: 45,
    createdAt: "2023-01-10T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 3,
    universityId: 2,
    universityNameEn: "Bogazici University",
    nameEn: "South Campus",
    nameLocal: "Güney Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 15000,
    clubCount: 32,
    eventCount: 78,
    createdAt: "2023-02-15T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 4,
    universityId: 2,
    universityNameEn: "Bogazici University",
    nameEn: "North Campus",
    nameLocal: "Kuzey Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 5000,
    clubCount: 12,
    eventCount: 28,
    createdAt: "2023-02-15T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 5,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    nameEn: "Main Campus",
    nameLocal: "Ana Kampüs",
    cityName: "Ankara",
    countryName: "Turkey",
    active: true,
    studentCount: 28000,
    clubCount: 65,
    eventCount: 200,
    createdAt: "2023-03-01T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 6,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    nameEn: "Cultural Campus",
    nameLocal: "Kültür Kampüsü",
    cityName: "Ankara",
    countryName: "Turkey",
    active: false,
    studentCount: 2000,
    clubCount: 5,
    eventCount: 10,
    createdAt: "2023-03-01T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 7,
    universityId: 4,
    universityNameEn: "Mersin University",
    nameEn: "Maslak Campus",
    nameLocal: "Maslak Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 22000,
    clubCount: 48,
    eventCount: 120,
    createdAt: "2023-01-10T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
  {
    id: 8,
    universityId: 4,
    universityNameEn: "Mersin University",
    nameEn: "Taskisla Campus",
    nameLocal: "Taşkışla Kampüsü",
    cityName: "Istanbul",
    countryName: "Turkey",
    active: true,
    studentCount: 8000,
    clubCount: 18,
    eventCount: 45,
    createdAt: "2023-01-10T10:00:00",
    updatedAt: "2025-06-01T10:00:00",
  },
];

export const MOCK_FACULTIES = [
  {
    id: 1,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    nameEn: "Faculty of Computer and Informatics",
    nameLocal: "Bilgisayar ve Bilişim Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
  {
    id: 2,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    nameEn: "Faculty of Electrical and Electronics Engineering",
    nameLocal: "Elektrik-Elektronik Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
  {
    id: 3,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 2,
    campusNameEn: "Taskisla Campus",
    nameEn: "Faculty of Architecture",
    nameLocal: "Mimarlık Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
  {
    id: 4,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 3,
    campusNameEn: "South Campus",
    nameEn: "Faculty of Engineering",
    nameLocal: "Mühendislik Fakültesi",
    active: true,
    createdAt: "2023-02-20T10:00:00",
  },
  {
    id: 5,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 3,
    campusNameEn: "South Campus",
    nameEn: "Faculty of Science",
    nameLocal: "Fen-Edebiyat Fakültesi",
    active: true,
    createdAt: "2023-02-20T10:00:00",
  },
  {
    id: 6,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 4,
    campusNameEn: "North Campus",
    nameEn: "Faculty of Arts and Sciences",
    nameLocal: "Arts and Sciences Fakültesi",
    active: true,
    createdAt: "2023-02-20T10:00:00",
  },
  {
    id: 7,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    campusNameEn: "Main Campus",
    nameEn: "Faculty of Engineering",
    nameLocal: "Mühendislik Fakültesi",
    active: true,
    createdAt: "2023-03-05T10:00:00",
  },
  {
    id: 8,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    campusNameEn: "Main Campus",
    nameEn: "Faculty of Natural Sciences",
    nameLocal: "Fen Bilimleri Fakültesi",
    active: true,
    createdAt: "2023-03-05T10:00:00",
  },
  {
    id: 9,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    nameEn: "Faculty of Computer and Informatics",
    nameLocal: "Bilgisayar ve Bilişim Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
  {
    id: 10,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    nameEn: "Faculty of Electrical and Electronics Engineering",
    nameLocal: "Elektrik-Elektronik Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
  {
    id: 11,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 8,
    campusNameEn: "Taskisla Campus",
    nameEn: "Faculty of Architecture",
    nameLocal: "Mimarlık Fakültesi",
    active: true,
    createdAt: "2023-01-15T10:00:00",
  },
];

export const MOCK_DEPARTMENTS = [
  {
    id: 1,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 1,
    facultyId: 1,
    nameEn: "Computer Engineering",
    nameLocal: "Bilgisayar Mühendisliği",
    facultyNameEn: "Faculty of Computer and Informatics",
    campusNameEn: "Maslak Campus",
    studentCount: 3200,
    active: true,
  },
  {
    id: 2,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 1,
    facultyId: 1,
    nameEn: "Artificial Intelligence Engineering",
    nameLocal: "Yapay Zeka Mühendisliği",
    facultyNameEn: "Faculty of Computer and Informatics",
    campusNameEn: "Maslak Campus",
    studentCount: 800,
    active: true,
  },
  {
    id: 3,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 1,
    facultyId: 2,
    nameEn: "Electrical Engineering",
    nameLocal: "Elektrik Mühendisliği",
    facultyNameEn: "Faculty of Electrical and Electronics Engineering",
    campusNameEn: "Maslak Campus",
    studentCount: 2800,
    active: true,
  },
  {
    id: 4,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    campusId: 2,
    facultyId: 3,
    nameEn: "Architecture",
    nameLocal: "Mimarlık",
    facultyNameEn: "Faculty of Architecture",
    campusNameEn: "Taskisla Campus",
    studentCount: 1500,
    active: true,
  },
  {
    id: 5,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 3,
    facultyId: 4,
    nameEn: "Mechanical Engineering",
    nameLocal: "Makine Mühendisliği",
    facultyNameEn: "Faculty of Engineering",
    campusNameEn: "South Campus",
    studentCount: 2100,
    active: true,
  },
  {
    id: 6,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 3,
    facultyId: 4,
    nameEn: "Civil Engineering",
    nameLocal: "İnşaat Mühendisliği",
    facultyNameEn: "Faculty of Engineering",
    campusNameEn: "South Campus",
    studentCount: 1900,
    active: true,
  },
  {
    id: 7,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 3,
    facultyId: 5,
    nameEn: "Physics",
    nameLocal: "Fizik",
    facultyNameEn: "Faculty of Science",
    campusNameEn: "South Campus",
    studentCount: 900,
    active: true,
  },
  {
    id: 8,
    universityId: 2,
    universityNameEn: "Bogazici University",
    campusId: 4,
    facultyId: 6,
    nameEn: "Mathematics",
    nameLocal: "Matematik",
    facultyNameEn: "Faculty of Arts and Sciences",
    campusNameEn: "North Campus",
    studentCount: 700,
    active: true,
  },
  {
    id: 9,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    facultyId: 7,
    nameEn: "Computer Engineering",
    nameLocal: "Bilgisayar Mühendisliği",
    facultyNameEn: "Faculty of Engineering",
    campusNameEn: "Main Campus",
    studentCount: 4200,
    active: true,
  },
  {
    id: 10,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    facultyId: 7,
    nameEn: "Industrial Engineering",
    nameLocal: "Endüstri Mühendisliği",
    facultyNameEn: "Faculty of Engineering",
    campusNameEn: "Main Campus",
    studentCount: 2700,
    active: true,
  },
  {
    id: 11,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    facultyId: 8,
    nameEn: "Chemistry",
    nameLocal: "Kimya",
    facultyNameEn: "Faculty of Natural Sciences",
    campusNameEn: "Main Campus",
    studentCount: 1100,
    active: true,
  },
  {
    id: 12,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    campusId: 5,
    facultyId: 8,
    nameEn: "Biology",
    nameLocal: "Biyoloji",
    facultyNameEn: "Faculty of Natural Sciences",
    campusNameEn: "Main Campus",
    studentCount: 950,
    active: true,
  },
  {
    id: 13,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 7,
    facultyId: 9,
    nameEn: "Computer Engineering",
    nameLocal: "Bilgisayar Mühendisliği",
    facultyNameEn: "Faculty of Computer and Informatics",
    campusNameEn: "Maslak Campus",
    studentCount: 3200,
    active: true,
  },
  {
    id: 14,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 7,
    facultyId: 9,
    nameEn: "Artificial Intelligence Engineering",
    nameLocal: "Yapay Zeka Mühendisliği",
    facultyNameEn: "Faculty of Computer and Informatics",
    campusNameEn: "Maslak Campus",
    studentCount: 800,
    active: true,
  },
  {
    id: 15,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 7,
    facultyId: 10,
    nameEn: "Electrical Engineering",
    nameLocal: "Elektrik Mühendisliği",
    facultyNameEn: "Faculty of Electrical and Electronics Engineering",
    campusNameEn: "Maslak Campus",
    studentCount: 2800,
    active: true,
  },
  {
    id: 16,
    universityId: 4,
    universityNameEn: "Mersin University",
    campusId: 8,
    facultyId: 11,
    nameEn: "Architecture",
    nameLocal: "Mimarlık",
    facultyNameEn: "Faculty of Architecture",
    campusNameEn: "Taskisla Campus",
    studentCount: 1500,
    active: true,
  },
];

export const MOCK_CLUBS = [
  {
    id: 1,
    universityId: 1,
    campusId: 1,
    nameEn: "ITU Robotics Club",
    nameLocal: "İTÜ Robotik Kulübü",
    descriptionEn:
      "Building autonomous robots and competing in national competitions",
    descriptionLocal:
      "Otonom robotlar inşa etmek ve ulusal yarışmalarda yarışmak",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Istanbul Technical University",
    totalMembers: 240,
    totalEvents: 18,
    categories: ["Technology"],
    active: true,
  },
  {
    id: 2,
    universityId: 1,
    campusId: 1,
    nameEn: "ITU Chess Club",
    nameLocal: "İTÜ Satranç Kulübü",
    descriptionEn: "Chess tournaments and training sessions for all levels",
    descriptionLocal:
      "Her seviye için satranç turnuvaları ve eğitim oturumları",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Istanbul Technical University",
    totalMembers: 95,
    totalEvents: 12,
    categories: ["Sports"],
    active: true,
  },
  {
    id: 3,
    universityId: 1,
    campusId: 2,
    nameEn: "ITU Architecture Society",
    nameLocal: "İTÜ Mimarlık Topluluğu",
    descriptionEn: "Architecture workshops and design exhibitions",
    descriptionLocal: "Mimarlık atölyeleri ve tasarım sergileri",
    campusNameEn: "Taskisla Campus",
    universityNameEn: "Istanbul Technical University",
    totalMembers: 120,
    totalEvents: 8,
    categories: ["Arts"],
    active: true,
  },
  {
    id: 4,
    universityId: 1,
    campusId: 1,
    nameEn: "ITU Photography Club",
    nameLocal: "İTÜ Fotoğrafçılık Kulübü",
    descriptionEn: "Photography workshops, exhibitions and photo walks",
    descriptionLocal: "Fotoğraf atölyeleri, sergiler ve fotoğraf yürüyüşleri",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Istanbul Technical University",
    totalMembers: 180,
    totalEvents: 22,
    categories: ["Arts"],
    active: true,
  },
  {
    id: 5,
    universityId: 2,
    campusId: 3,
    nameEn: "BOUN Debate Club",
    nameLocal: "BOUN Münazara Kulübü",
    descriptionEn: "Competitive debate and public speaking training",
    descriptionLocal: "Rekabetçi münazara ve topluluk önünde konuşma eğitimi",
    campusNameEn: "South Campus",
    universityNameEn: "Bogazici University",
    totalMembers: 75,
    totalEvents: 14,
    categories: ["Social"],
    active: true,
  },
  {
    id: 6,
    universityId: 2,
    campusId: 3,
    nameEn: "BOUN Astronomy Club",
    nameLocal: "BOUN Astronomi Kulübü",
    descriptionEn: "Star gazing events and astronomy discussions",
    descriptionLocal: "Yıldız gözlem etkinlikleri ve astronomi tartışmaları",
    campusNameEn: "South Campus",
    universityNameEn: "Bogazici University",
    totalMembers: 60,
    totalEvents: 9,
    categories: ["Science"],
    active: true,
  },
  {
    id: 7,
    universityId: 2,
    campusId: 4,
    nameEn: "BOUN Film Club",
    nameLocal: "BOUN Film Kulübü",
    descriptionEn: "Film screenings and cinema discussions",
    descriptionLocal: "Film gösterimleri ve sinema tartışmaları",
    campusNameEn: "North Campus",
    universityNameEn: "Bogazici University",
    totalMembers: 110,
    totalEvents: 16,
    categories: ["Arts"],
    active: false,
  },
  {
    id: 8,
    universityId: 2,
    campusId: 3,
    nameEn: "BOUN Entrepreneurship Club",
    nameLocal: "BOUN Girişimcilik Kulübü",
    descriptionEn: "Startup mentorship and entrepreneurship events",
    descriptionLocal: "Girişim mentorluğu ve girişimcilik etkinlikleri",
    campusNameEn: "South Campus",
    universityNameEn: "Bogazici University",
    totalMembers: 200,
    totalEvents: 25,
    categories: ["Business"],
    active: true,
  },
  {
    id: 9,
    universityId: 3,
    campusId: 5,
    nameEn: "METU AI & ML Club",
    nameLocal: "ODTÜ YZ & MÖ Kulübü",
    descriptionEn: "Machine learning workshops and AI projects",
    descriptionLocal: "Makine öğrenimi atölyeleri ve yapay zeka projeleri",
    campusNameEn: "Main Campus",
    universityNameEn: "Middle East Technical University",
    totalMembers: 320,
    totalEvents: 30,
    categories: ["Technology"],
    active: true,
  },
  {
    id: 10,
    universityId: 3,
    campusId: 5,
    nameEn: "METU Music Club",
    nameLocal: "ODTÜ Müzik Kulübü",
    descriptionEn: "Live music performances and music education",
    descriptionLocal: "Canlı müzik performansları ve müzik eğitimi",
    campusNameEn: "Main Campus",
    universityNameEn: "Middle East Technical University",
    totalMembers: 150,
    totalEvents: 20,
    categories: ["Arts"],
    active: true,
  },
  {
    id: 11,
    universityId: 3,
    campusId: 5,
    nameEn: "METU Hiking Club",
    nameLocal: "ODTÜ Doğa Yürüyüşü Kulübü",
    descriptionEn: "Weekend hiking trips and nature activities",
    descriptionLocal: "Hafta sonu doğa yürüyüşleri ve doğa aktiviteleri",
    campusNameEn: "Main Campus",
    universityNameEn: "Middle East Technical University",
    totalMembers: 280,
    totalEvents: 35,
    categories: ["Sports"],
    active: true,
  },
  {
    id: 12,
    universityId: 3,
    campusId: 5,
    nameEn: "METU Sustainability Club",
    nameLocal: "ODTÜ Sürdürülebilirlik Kulübü",
    descriptionEn: "Environmental awareness and sustainability projects",
    descriptionLocal: "Çevre bilinci ve sürdürülebilirlik projeleri",
    campusNameEn: "Main Campus",
    universityNameEn: "Middle East Technical University",
    totalMembers: 130,
    totalEvents: 15,
    categories: ["Social"],
    active: true,
  },
  {
    id: 13,
    universityId: 4,
    campusId: 7,
    nameEn: "MEU Robotics Club",
    nameLocal: "MEU Robotik Kulübü",
    descriptionEn:
      "Building autonomous robots and competing in national competitions",
    descriptionLocal:
      "Otonom robotlar inşa etmek ve ulusal yarışmalarda yarışmak",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Mersin University",
    totalMembers: 240,
    totalEvents: 18,
    categories: ["Technology"],
    active: true,
  },
  {
    id: 14,
    universityId: 4,
    campusId: 7,
    nameEn: "MEU Chess Club",
    nameLocal: "MEU Satranç Kulübü",
    descriptionEn: "Chess tournaments and training sessions for all levels",
    descriptionLocal:
      "Her seviye için satranç turnuvaları ve eğitim oturumları",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Mersin University",
    totalMembers: 95,
    totalEvents: 12,
    categories: ["Sports"],
    active: true,
  },
  {
    id: 15,
    universityId: 4,
    campusId: 8,
    nameEn: "MEU Architecture Society",
    nameLocal: "MEU Mimarlık Topluluğu",
    descriptionEn: "Architecture workshops and design exhibitions",
    descriptionLocal: "Mimarlık atölyeleri ve tasarım sergileri",
    campusNameEn: "Taskisla Campus",
    universityNameEn: "Mersin University",
    totalMembers: 120,
    totalEvents: 8,
    categories: ["Arts"],
    active: true,
  },
  {
    id: 16,
    universityId: 4,
    campusId: 7,
    nameEn: "MEU Photography Club",
    nameLocal: "MEU Fotoğrafçılık Kulübü",
    descriptionEn: "Photography workshops, exhibitions and photo walks",
    descriptionLocal: "Fotoğraf atölyeleri, sergiler ve fotoğraf yürüyüşleri",
    campusNameEn: "Maslak Campus",
    universityNameEn: "Mersin University",
    totalMembers: 180,
    totalEvents: 22,
    categories: ["Arts"],
    active: true,
  },
];

export const MOCK_CLUB_DETAILS = {
  1: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "İstanbul Teknik Üniversitesi",
    contactEmail: "robotics@itu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-robotics/320/320",
    communication: {
      email: "hello.robotics@itu.edu.tr",
      phone_number: "+90 212 285 6001",
      instagram: "iturobotics",
      twitter: "iturobotics",
      whatsapp_phone_number: "+90 530 000 00 01",
    },
    categories: [{ id: 1, nameEn: "Technology", nameLocal: "Teknoloji" }],
  },
  2: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "İstanbul Teknik Üniversitesi",
    contactEmail: "chess@itu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-chess/320/320",
    communication: {
      email: "chess.community@itu.edu.tr",
      phone_number: "+90 212 285 6002",
      instagram: "ituchess",
      twitter: "ituchess",
      whatsapp_phone_number: "+90 530 000 00 02",
    },
    categories: [{ id: 2, nameEn: "Sports", nameLocal: "Spor" }],
  },
  3: {
    campusNameLocal: "Taşkışla Kampüsü",
    universityNameLocal: "İstanbul Teknik Üniversitesi",
    contactEmail: "architecture@itu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-architecture/320/320",
    communication: {
      email: "arch.society@itu.edu.tr",
      phone_number: "+90 212 285 6003",
      instagram: "ituarchitecture",
      twitter: "ituarchitecture",
      whatsapp_phone_number: "+90 530 000 00 03",
    },
    categories: [{ id: 3, nameEn: "Arts", nameLocal: "Sanat" }],
  },
  4: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "İstanbul Teknik Üniversitesi",
    contactEmail: "photography@itu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-photography/320/320",
    communication: {
      email: "photo.club@itu.edu.tr",
      phone_number: "+90 212 285 6004",
      instagram: "ituphotography",
      twitter: "ituphotography",
      whatsapp_phone_number: "+90 530 000 00 04",
    },
    categories: [{ id: 4, nameEn: "Arts", nameLocal: "Sanat" }],
  },
  5: {
    campusNameLocal: "Güney Kampüsü",
    universityNameLocal: "Boğaziçi Üniversitesi",
    contactEmail: "debate@boun.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-debate/320/320",
    communication: {
      email: "debate.club@boun.edu.tr",
      phone_number: "+90 212 359 7005",
      instagram: "boundebate",
      twitter: "boundebate",
      whatsapp_phone_number: "+90 531 000 00 05",
    },
    categories: [{ id: 5, nameEn: "Social", nameLocal: "Sosyal" }],
  },
  6: {
    campusNameLocal: "Güney Kampüsü",
    universityNameLocal: "Boğaziçi Üniversitesi",
    contactEmail: "astronomy@boun.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-astronomy/320/320",
    communication: {
      email: "astro.club@boun.edu.tr",
      phone_number: "+90 212 359 7006",
      instagram: "bounastronomy",
      twitter: "bounastronomy",
      whatsapp_phone_number: "+90 531 000 00 06",
    },
    categories: [{ id: 6, nameEn: "Science", nameLocal: "Bilim" }],
  },
  7: {
    campusNameLocal: "Kuzey Kampüsü",
    universityNameLocal: "Boğaziçi Üniversitesi",
    contactEmail: "film@boun.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-film/320/320",
    communication: {
      email: "film.club@boun.edu.tr",
      phone_number: "+90 212 359 7007",
      instagram: "bounfilm",
      twitter: "bounfilm",
      whatsapp_phone_number: "+90 531 000 00 07",
    },
    categories: [{ id: 7, nameEn: "Arts", nameLocal: "Sanat" }],
  },
  8: {
    campusNameLocal: "Güney Kampüsü",
    universityNameLocal: "Boğaziçi Üniversitesi",
    contactEmail: "entrepreneurship@boun.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-entrepreneurship/320/320",
    communication: {
      email: "startup.club@boun.edu.tr",
      phone_number: "+90 212 359 7008",
      instagram: "bounstartup",
      twitter: "bounstartup",
      whatsapp_phone_number: "+90 531 000 00 08",
    },
    categories: [{ id: 8, nameEn: "Business", nameLocal: "İş Dünyası" }],
  },
  9: {
    campusNameLocal: "Ana Kampüs",
    universityNameLocal: "Orta Doğu Teknik Üniversitesi",
    contactEmail: "aiml@metu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-aiml/320/320",
    communication: {
      email: "aiml.club@metu.edu.tr",
      phone_number: "+90 312 210 8009",
      instagram: "metuaiml",
      twitter: "metuaiml",
      whatsapp_phone_number: "+90 532 000 00 09",
    },
    categories: [{ id: 9, nameEn: "Technology", nameLocal: "Teknoloji" }],
  },
  10: {
    campusNameLocal: "Ana Kampüs",
    universityNameLocal: "Orta Doğu Teknik Üniversitesi",
    contactEmail: "music@metu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-music/320/320",
    communication: {
      email: "music.club@metu.edu.tr",
      phone_number: "+90 312 210 8010",
      instagram: "metumusic",
      twitter: "metumusic",
      whatsapp_phone_number: "+90 532 000 00 10",
    },
    categories: [{ id: 10, nameEn: "Arts", nameLocal: "Sanat" }],
  },
  11: {
    campusNameLocal: "Ana Kampüs",
    universityNameLocal: "Orta Doğu Teknik Üniversitesi",
    contactEmail: "hiking@metu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-hiking/320/320",
    communication: {
      email: "hiking.club@metu.edu.tr",
      phone_number: "+90 312 210 8011",
      instagram: "metuhiking",
      twitter: "metuhiking",
      whatsapp_phone_number: "+90 532 000 00 11",
    },
    categories: [{ id: 11, nameEn: "Sports", nameLocal: "Spor" }],
  },
  12: {
    campusNameLocal: "Ana Kampüs",
    universityNameLocal: "Orta Doğu Teknik Üniversitesi",
    contactEmail: "sustainability@metu.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-sustainability/320/320",
    communication: {
      email: "green.club@metu.edu.tr",
      phone_number: "+90 312 210 8012",
      instagram: "metugreen",
      twitter: "metugreen",
      whatsapp_phone_number: "+90 532 000 00 12",
    },
    categories: [{ id: 12, nameEn: "Social", nameLocal: "Sosyal" }],
  },
  13: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "Mersin Üniversitesi",
    contactEmail: "robotics@MEU.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-robotics/320/320",
    communication: {
      email: "hello.robotics@MEU.edu.tr",
      phone_number: "+90 212 400 6001",
      instagram: "MEUrobotics",
      twitter: "MEUrobotics",
      whatsapp_phone_number: "+90 530 400 00 01",
    },
    categories: [{ id: 1, nameEn: "Technology", nameLocal: "Teknoloji" }],
  },
  14: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "Mersin Üniversitesi",
    contactEmail: "chess@MEU.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-chess/320/320",
    communication: {
      email: "chess.community@MEU.edu.tr",
      phone_number: "+90 212 400 6002",
      instagram: "MEUchess",
      twitter: "MEUchess",
      whatsapp_phone_number: "+90 530 400 00 02",
    },
    categories: [{ id: 2, nameEn: "Sports", nameLocal: "Spor" }],
  },
  15: {
    campusNameLocal: "Taşkışla Kampüsü",
    universityNameLocal: "Mersin Üniversitesi",
    contactEmail: "architecture@MEU.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-architecture/320/320",
    communication: {
      email: "arch.society@MEU.edu.tr",
      phone_number: "+90 212 400 6003",
      instagram: "MEUarchitecture",
      twitter: "MEUarchitecture",
      whatsapp_phone_number: "+90 530 400 00 03",
    },
    categories: [{ id: 3, nameEn: "Arts", nameLocal: "Sanat" }],
  },
  16: {
    campusNameLocal: "Maslak Kampüsü",
    universityNameLocal: "Mersin Üniversitesi",
    contactEmail: "photography@MEU.edu.tr",
    imageUrl: "https://picsum.photos/seed/club-photography/320/320",
    communication: {
      email: "photo.club@MEU.edu.tr",
      phone_number: "+90 212 400 6004",
      instagram: "MEUphotography",
      twitter: "MEUphotography",
      whatsapp_phone_number: "+90 530 400 00 04",
    },
    categories: [{ id: 4, nameEn: "Arts", nameLocal: "Sanat" }],
  },
};

export const MOCK_EVENTS = [
  {
    id: 1,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    titleEn: "Annual Robotics Competition",
    titleLocal: "Yıllık Robotik Yarışması",
    descriptionEn: "Annual competition showcasing the best autonomous robots",
    descriptionLocal: "En iyi otonom robotları sergileyen yıllık yarışma",
    startDate: "2026-03-15T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/robotics-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/robotics-tr/800/450",
  },
  {
    id: 2,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 2,
    clubNameEn: "ITU Chess Club",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    titleEn: "Spring Chess Tournament",
    titleLocal: "Bahar Satranç Turnuvası",
    descriptionEn: "Competitive chess tournament open to all players",
    descriptionLocal: "Tüm oyunculara açık rekabetçi satranç turnuvası",
    startDate: "2026-03-20T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 50,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/chess-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/chess-tr/800/450",
  },
  {
    id: 3,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 4,
    clubNameEn: "ITU Photography Club",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    titleEn: "Urban Lens Exhibition",
    titleLocal: "Kent Mercek Sergisi",
    descriptionEn: "Photography exhibition showcasing urban landscapes",
    descriptionLocal: "Kentsel manzaraları sergileyen fotoğraf sergisi",
    startDate: "2026-02-28T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/photography-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/photography-tr/800/450",
  },
  {
    id: 4,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 3,
    clubNameEn: "ITU Architecture Society",
    campusId: 2,
    campusNameEn: "Taskisla Campus",
    titleEn: "Design Workshop 2026",
    titleLocal: "Tasarım Atölyesi 2026",
    descriptionEn: "Hands-on design workshop for architecture students",
    descriptionLocal: "Mimarlık öğrencileri için uygulamalı tasarım atölyesi",
    startDate: "2026-03-05T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 100,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/architecture-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/architecture-tr/800/450",
  },
  {
    id: 5,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    titleEn: "Intro to Arduino",
    titleLocal: "Arduino'ya Giriş",
    descriptionEn: "Beginner-friendly introduction to Arduino programming",
    descriptionLocal: "Yeni başlayanlar için Arduino programlamaya giriş",
    startDate: "2026-02-20T14:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "COMPLETED",
    imageUrlEn: "https://picsum.photos/seed/arduino-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/arduino-tr/800/450",
  },
  {
    id: 6,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 4,
    clubNameEn: "ITU Photography Club",
    campusId: 1,
    campusNameEn: "Maslak Campus",
    titleEn: "Night Photography Walk",
    titleLocal: "Gece Fotoğrafçılığı Yürüyüşü",
    descriptionEn: "Night photography session around Istanbul",
    descriptionLocal: "İstanbul çevresinde gece fotoğrafçılığı oturumu",
    startDate: "2026-04-10T20:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 30,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/nightphoto-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/nightphoto-tr/800/450",
  },
  {
    id: 7,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 5,
    clubNameEn: "BOUN Debate Club",
    campusId: 3,
    campusNameEn: "South Campus",
    titleEn: "Inter-University Debate",
    titleLocal: "Üniversiteler Arası Münazara",
    descriptionEn: "Debate competition between universities",
    descriptionLocal: "Üniversiteler arası münazara yarışması",
    startDate: "2026-03-25T13:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/debate-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/debate-tr/800/450",
  },
  {
    id: 8,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 6,
    clubNameEn: "BOUN Astronomy Club",
    campusId: 3,
    campusNameEn: "South Campus",
    titleEn: "Star Gazing Night",
    titleLocal: "Yıldız İzleme Gecesi",
    descriptionEn: "Evening of star gazing with telescopes",
    descriptionLocal: "Teleskoplarla yıldız gözlem akşamı",
    startDate: "2026-04-05T21:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 20,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/astronomy-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/astronomy-tr/800/450",
  },
  {
    id: 9,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 8,
    clubNameEn: "BOUN Entrepreneurship Club",
    campusId: 3,
    campusNameEn: "South Campus",
    titleEn: "Startup Pitch Day",
    titleLocal: "Girişim Sunum Günü",
    descriptionEn: "Pitch your startup ideas to investors",
    descriptionLocal: "Girişim fikirlerinizi yatırımcılara sunun",
    startDate: "2026-03-18T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/startup-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/startup-tr/800/450",
  },
  {
    id: 10,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 5,
    clubNameEn: "BOUN Debate Club",
    campusId: 3,
    campusNameEn: "South Campus",
    titleEn: "Model UN Conference",
    titleLocal: "Model BM Konferansı",
    descriptionEn: "Multi-day Model United Nations conference",
    descriptionLocal: "Çok günlük Model Birleşmiş Milletler konferansı",
    startDate: "2026-04-20T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 150,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/modelun-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/modelun-tr/800/450",
  },
  {
    id: 11,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 7,
    clubNameEn: "BOUN Film Club",
    campusId: 4,
    campusNameEn: "North Campus",
    titleEn: "Film Screening Night",
    titleLocal: "Film Gösterim Gecesi",
    descriptionEn: "Screening of classic international films",
    descriptionLocal: "Klasik uluslararası filmlerin gösterimi",
    startDate: "2026-02-25T19:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 25,
    approvalStatus: "REJECTED",
    eventStatus: "CANCELLED",
    rejectionReason: "Venue not available",
    imageUrlEn: "https://picsum.photos/seed/cinema-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/cinema-tr/800/450",
  },
  {
    id: 12,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 8,
    clubNameEn: "BOUN Entrepreneurship Club",
    campusId: 3,
    campusNameEn: "South Campus",
    titleEn: "VC Panel Discussion",
    titleLocal: "VC Paneli",
    descriptionEn: "Panel discussion with venture capitalists",
    descriptionLocal: "Girişim sermayedarları ile panel tartışması",
    startDate: "2026-03-30T14:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/vcpanel-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/vcpanel-tr/800/450",
  },
  {
    id: 13,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 9,
    clubNameEn: "METU AI & ML Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "AI Hackathon 2026",
    titleLocal: "YZ Hackathon 2026",
    descriptionEn: "48-hour AI and machine learning hackathon",
    descriptionLocal: "48 saatlik yapay zeka ve makine öğrenimi hackathonu",
    startDate: "2026-03-22T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/aihack-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/aihack-tr/800/450",
  },
  {
    id: 14,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 10,
    clubNameEn: "METU Music Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Spring Concert",
    titleLocal: "Bahar Konseri",
    descriptionEn: "Annual spring concert featuring student performers",
    descriptionLocal: "Öğrenci performanslarını içeren yıllık bahar konseri",
    startDate: "2026-04-15T19:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 75,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/concert-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/concert-tr/800/450",
  },
  {
    id: 15,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Cappadocia Trek",
    titleLocal: "Kapadokya Yürüyüşü",
    descriptionEn: "Weekend hiking trip to Cappadocia",
    descriptionLocal: "Kapadokya'ya hafta sonu yürüyüş gezisi",
    startDate: "2026-05-01T07:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 500,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/cappadocia-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/cappadocia-tr/800/450",
  },
  {
    id: 16,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 9,
    clubNameEn: "METU AI & ML Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Deep Learning Workshop",
    titleLocal: "Derin Öğrenme Atölyesi",
    descriptionEn: "Introduction to deep learning and neural networks",
    descriptionLocal: "Derin öğrenme ve sinir ağlarına giriş",
    startDate: "2026-02-22T10:00:00",
    participationType: "ONLINE",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "COMPLETED",
    imageUrlEn: "https://picsum.photos/seed/deeplearn-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/deeplearn-tr/800/450",
  },
  {
    id: 17,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 12,
    clubNameEn: "METU Sustainability Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Campus Green Fair",
    titleLocal: "Kampüs Yeşil Fuarı",
    descriptionEn: "Environmental awareness fair on campus",
    descriptionLocal: "Kampüste çevre bilinci fuarı",
    startDate: "2026-04-22T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/greenfair-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/greenfair-tr/800/450",
  },
  {
    id: 18,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 10,
    clubNameEn: "METU Music Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Jazz Evening",
    titleLocal: "Caz Gecesi",
    descriptionEn: "Evening of live jazz performances",
    descriptionLocal: "Canlı caz performansları akşamı",
    startDate: "2026-03-10T19:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 50,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/jazznight-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/jazznight-tr/800/450",
  },
  {
    id: 19,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Uludag Winter Hike",
    titleLocal: "Uludağ Kış Yürüyüşü",
    descriptionEn: "Winter hiking trip to Uludag mountain",
    descriptionLocal: "Uludağ'a kış yürüyüş gezisi",
    startDate: "2026-02-18T07:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 300,
    approvalStatus: "APPROVED",
    eventStatus: "COMPLETED",
    imageUrlEn: "https://picsum.photos/seed/winterhike-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/winterhike-tr/800/450",
  },
  {
    id: 20,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 12,
    clubNameEn: "METU Sustainability Club",
    campusId: 5,
    campusNameEn: "Main Campus",
    titleEn: "Recycling Workshop",
    titleLocal: "Geri Dönüşüm Atölyesi",
    descriptionEn: "Workshop on recycling and waste management",
    descriptionLocal: "Geri dönüşüm ve atık yönetimi atölyesi",
    startDate: "2026-03-08T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "COMPLETED",
    imageUrlEn: "https://picsum.photos/seed/recycling-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/recycling-tr/800/450",
  },
  {
    id: 21,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    titleEn: "Annual Robotics Competition",
    titleLocal: "Yıllık Robotik Yarışması",
    descriptionEn: "Annual competition showcasing the best autonomous robots",
    descriptionLocal: "En iyi otonom robotları sergileyen yıllık yarışma",
    startDate: "2026-03-15T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/robotics-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/robotics-tr/800/450",
  },
  {
    id: 22,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 14,
    clubNameEn: "MEU Chess Club",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    titleEn: "Spring Chess Tournament",
    titleLocal: "Bahar Satranç Turnuvası",
    descriptionEn: "Competitive chess tournament open to all players",
    descriptionLocal: "Tüm oyunculara açık rekabetçi satranç turnuvası",
    startDate: "2026-03-20T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 50,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/chess-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/chess-tr/800/450",
  },
  {
    id: 23,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 16,
    clubNameEn: "MEU Photography Club",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    titleEn: "Urban Lens Exhibition",
    titleLocal: "Kent Mercek Sergisi",
    descriptionEn: "Photography exhibition showcasing urban landscapes",
    descriptionLocal: "Kentsel manzaraları sergileyen fotoğraf sergisi",
    startDate: "2026-02-28T10:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/photography-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/photography-tr/800/450",
  },
  {
    id: 24,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 15,
    clubNameEn: "MEU Architecture Society",
    campusId: 8,
    campusNameEn: "Taskisla Campus",
    titleEn: "Design Workshop 2026",
    titleLocal: "Tasarım Atölyesi 2026",
    descriptionEn: "Hands-on design workshop for architecture students",
    descriptionLocal: "Mimarlık öğrencileri için uygulamalı tasarım atölyesi",
    startDate: "2026-03-05T09:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 100,
    approvalStatus: "APPROVED",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/architecture-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/architecture-tr/800/450",
  },
  {
    id: 25,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    titleEn: "Intro to Arduino",
    titleLocal: "Arduino'ya Giriş",
    descriptionEn: "Beginner-friendly introduction to Arduino programming",
    descriptionLocal: "Yeni başlayanlar için Arduino programlamaya giriş",
    startDate: "2026-02-20T14:00:00",
    participationType: "PHYSICAL",
    participationScope: "UNIVERSITY_ONLY",
    price: 0,
    approvalStatus: "APPROVED",
    eventStatus: "COMPLETED",
    imageUrlEn: "https://picsum.photos/seed/arduino-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/arduino-tr/800/450",
  },
  {
    id: 26,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 16,
    clubNameEn: "MEU Photography Club",
    campusId: 7,
    campusNameEn: "Maslak Campus",
    titleEn: "Night Photography Walk",
    titleLocal: "Gece Fotoğrafçılığı Yürüyüşü",
    descriptionEn: "Night photography session around Istanbul",
    descriptionLocal: "İstanbul çevresinde gece fotoğrafçılığı oturumu",
    startDate: "2026-04-10T20:00:00",
    participationType: "PHYSICAL",
    participationScope: "PUBLIC",
    price: 30,
    approvalStatus: "PENDING",
    eventStatus: "UPCOMING",
    imageUrlEn: "https://picsum.photos/seed/nightphoto-en/800/450",
    imageUrlLocal: "https://picsum.photos/seed/nightphoto-tr/800/450",
  },
];

export const MOCK_TRANSFERS = [
  {
    id: 1,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    fromUser: "Ali Yilmaz",
    toClub: "ITU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-15",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 2,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    fromUser: "Ayse Kaya",
    toClub: "ITU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-16",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 3,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 2,
    clubNameEn: "ITU Chess Club",
    fromUser: "Mehmet Demir",
    toClub: "ITU Chess Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-20",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 4,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 4,
    clubNameEn: "ITU Photography Club",
    fromUser: "Fatma Sahin",
    toClub: "ITU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-01-22",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "PENDING",
  },
  {
    id: 5,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    fromUser: "Hasan Ozturk",
    toClub: "ITU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-25",
    type: "APPLYING_EVENT",
    transferType: "REFUND",
    status: "REFUNDED",
  },
  {
    id: 6,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 3,
    clubNameEn: "ITU Architecture Society",
    fromUser: "Zeynep Yildiz",
    toClub: "ITU Architecture Society",
    amount: 100,
    currency: "TRY",
    date: "2026-01-28",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 7,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 4,
    clubNameEn: "ITU Photography Club",
    fromUser: "Emre Arslan",
    toClub: "ITU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-02-01",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "FAILED",
  },
  {
    id: 8,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 2,
    clubNameEn: "ITU Chess Club",
    fromUser: "Deniz Celik",
    toClub: "ITU Chess Club",
    amount: 50,
    currency: "TRY",
    date: "2026-02-05",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 9,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 1,
    clubNameEn: "ITU Robotics Club",
    fromUser: "Burcu Kaplan",
    toClub: "ITU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-02-10",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 10,
    universityId: 1,
    universityNameEn: "Istanbul Technical University",
    clubId: 4,
    clubNameEn: "ITU Photography Club",
    fromUser: "Serkan Mutlu",
    toClub: "ITU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-02-12",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 11,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 5,
    clubNameEn: "BOUN Debate Club",
    fromUser: "Lara Ekici",
    toClub: "BOUN Debate Club",
    amount: 0,
    currency: "TRY",
    date: "2026-01-18",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 12,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 8,
    clubNameEn: "BOUN Entrepreneurship Club",
    fromUser: "Can Dogan",
    toClub: "BOUN Entrepreneurship Club",
    amount: 0,
    currency: "TRY",
    date: "2026-01-21",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 13,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 5,
    clubNameEn: "BOUN Debate Club",
    fromUser: "Ipek Yurt",
    toClub: "BOUN Debate Club",
    amount: 150,
    currency: "TRY",
    date: "2026-01-30",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 14,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 6,
    clubNameEn: "BOUN Astronomy Club",
    fromUser: "Gokhan Uslu",
    toClub: "BOUN Astronomy Club",
    amount: 20,
    currency: "TRY",
    date: "2026-02-02",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 15,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 7,
    clubNameEn: "BOUN Film Club",
    fromUser: "Selin Bas",
    toClub: "BOUN Film Club",
    amount: 25,
    currency: "TRY",
    date: "2026-02-06",
    type: "APPLYING_EVENT",
    transferType: "REFUND",
    status: "REFUNDED",
  },
  {
    id: 16,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 8,
    clubNameEn: "BOUN Entrepreneurship Club",
    fromUser: "Tunc Ozkan",
    toClub: "BOUN Entrepreneurship Club",
    amount: 0,
    currency: "TRY",
    date: "2026-02-08",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 17,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 5,
    clubNameEn: "BOUN Debate Club",
    fromUser: "Reyhan Koc",
    toClub: "BOUN Debate Club",
    amount: 150,
    currency: "TRY",
    date: "2026-02-14",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "PENDING",
  },
  {
    id: 18,
    universityId: 2,
    universityNameEn: "Bogazici University",
    clubId: 6,
    clubNameEn: "BOUN Astronomy Club",
    fromUser: "Berk Sezgin",
    toClub: "BOUN Astronomy Club",
    amount: 20,
    currency: "TRY",
    date: "2026-02-15",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 19,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 9,
    clubNameEn: "METU AI & ML Club",
    fromUser: "Cem Akar",
    toClub: "METU AI & ML Club",
    amount: 0,
    currency: "TRY",
    date: "2026-01-12",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 20,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    fromUser: "Seda Yalcin",
    toClub: "METU Hiking Club",
    amount: 300,
    currency: "TRY",
    date: "2026-01-17",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 21,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 10,
    clubNameEn: "METU Music Club",
    fromUser: "Kerem Duman",
    toClub: "METU Music Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-23",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 22,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 9,
    clubNameEn: "METU AI & ML Club",
    fromUser: "Naz Ercan",
    toClub: "METU AI & ML Club",
    amount: 0,
    currency: "TRY",
    date: "2026-01-26",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 23,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 12,
    clubNameEn: "METU Sustainability Club",
    fromUser: "Tolga Aydin",
    toClub: "METU Sustainability Club",
    amount: 0,
    currency: "TRY",
    date: "2026-01-29",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 24,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    fromUser: "Gamze Sen",
    toClub: "METU Hiking Club",
    amount: 500,
    currency: "TRY",
    date: "2026-02-03",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 25,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 10,
    clubNameEn: "METU Music Club",
    fromUser: "Efe Topcu",
    toClub: "METU Music Club",
    amount: 75,
    currency: "TRY",
    date: "2026-02-07",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 26,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    fromUser: "Ceren Kaya",
    toClub: "METU Hiking Club",
    amount: 300,
    currency: "TRY",
    date: "2026-02-09",
    type: "APPLYING_EVENT",
    transferType: "REFUND",
    status: "REFUNDED",
  },
  {
    id: 27,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 9,
    clubNameEn: "METU AI & ML Club",
    fromUser: "Bora Ozkan",
    toClub: "METU AI & ML Club",
    amount: 0,
    currency: "TRY",
    date: "2026-02-11",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 28,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 12,
    clubNameEn: "METU Sustainability Club",
    fromUser: "Elif Turk",
    toClub: "METU Sustainability Club",
    amount: 0,
    currency: "TRY",
    date: "2026-02-13",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "FAILED",
  },
  {
    id: 29,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 10,
    clubNameEn: "METU Music Club",
    fromUser: "Mert Ozdemir",
    toClub: "METU Music Club",
    amount: 50,
    currency: "TRY",
    date: "2026-02-16",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "PENDING",
  },
  {
    id: 30,
    universityId: 3,
    universityNameEn: "Middle East Technical University",
    clubId: 11,
    clubNameEn: "METU Hiking Club",
    fromUser: "Yagmur Arslan",
    toClub: "METU Hiking Club",
    amount: 500,
    currency: "TRY",
    date: "2026-02-17",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 31,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    fromUser: "Ali Yilmaz",
    toClub: "MEU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-15",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 32,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    fromUser: "Ayse Kaya",
    toClub: "MEU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-16",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 33,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 14,
    clubNameEn: "MEU Chess Club",
    fromUser: "Mehmet Demir",
    toClub: "MEU Chess Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-20",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 34,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 16,
    clubNameEn: "MEU Photography Club",
    fromUser: "Fatma Sahin",
    toClub: "MEU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-01-22",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "PENDING",
  },
  {
    id: 35,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    fromUser: "Hasan Ozturk",
    toClub: "MEU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-01-25",
    type: "APPLYING_EVENT",
    transferType: "REFUND",
    status: "REFUNDED",
  },
  {
    id: 36,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 15,
    clubNameEn: "MEU Architecture Society",
    fromUser: "Zeynep Yildiz",
    toClub: "MEU Architecture Society",
    amount: 100,
    currency: "TRY",
    date: "2026-01-28",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 37,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 16,
    clubNameEn: "MEU Photography Club",
    fromUser: "Emre Arslan",
    toClub: "MEU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-02-01",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "FAILED",
  },
  {
    id: 38,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 14,
    clubNameEn: "MEU Chess Club",
    fromUser: "Deniz Celik",
    toClub: "MEU Chess Club",
    amount: 50,
    currency: "TRY",
    date: "2026-02-05",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 39,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 13,
    clubNameEn: "MEU Robotics Club",
    fromUser: "Burcu Kaplan",
    toClub: "MEU Robotics Club",
    amount: 50,
    currency: "TRY",
    date: "2026-02-10",
    type: "JOINING_CLUB",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
  {
    id: 40,
    universityId: 4,
    universityNameEn: "Mersin University",
    clubId: 16,
    clubNameEn: "MEU Photography Club",
    fromUser: "Serkan Mutlu",
    toClub: "MEU Photography Club",
    amount: 30,
    currency: "TRY",
    date: "2026-02-12",
    type: "APPLYING_EVENT",
    transferType: "PAYMENT",
    status: "COMPLETED",
  },
];

export const MOCK_MONTHLY_ANALYTICS = {
  1: [
    {
      month: "Jan",
      income: 330,
      expense: 120,
      net: 210,
      topClub: "ITU Robotics Club",
    },
    {
      month: "Feb",
      income: 260,
      expense: 90,
      net: 170,
      topClub: "ITU Photography Club",
    },
    {
      month: "Mar",
      income: 480,
      expense: 150,
      net: 330,
      topClub: "ITU Architecture Society",
    },
    {
      month: "Apr",
      income: 390,
      expense: 110,
      net: 280,
      topClub: "ITU Robotics Club",
    },
    {
      month: "May",
      income: 310,
      expense: 100,
      net: 210,
      topClub: "ITU Chess Club",
    },
    {
      month: "Jun",
      income: 200,
      expense: 70,
      net: 130,
      topClub: "ITU Photography Club",
    },
    {
      month: "Jul",
      income: 150,
      expense: 50,
      net: 100,
      topClub: "ITU Robotics Club",
    },
    {
      month: "Aug",
      income: 120,
      expense: 40,
      net: 80,
      topClub: "ITU Photography Club",
    },
    {
      month: "Sep",
      income: 280,
      expense: 90,
      net: 190,
      topClub: "ITU Architecture Society",
    },
    {
      month: "Oct",
      income: 420,
      expense: 140,
      net: 280,
      topClub: "ITU Robotics Club",
    },
    {
      month: "Nov",
      income: 500,
      expense: 180,
      net: 320,
      topClub: "ITU Chess Club",
    },
    {
      month: "Dec",
      income: 360,
      expense: 120,
      net: 240,
      topClub: "ITU Photography Club",
    },
  ],
  2: [
    {
      month: "Jan",
      income: 170,
      expense: 60,
      net: 110,
      topClub: "BOUN Debate Club",
    },
    {
      month: "Feb",
      income: 215,
      expense: 80,
      net: 135,
      topClub: "BOUN Entrepreneurship Club",
    },
    {
      month: "Mar",
      income: 290,
      expense: 100,
      net: 190,
      topClub: "BOUN Entrepreneurship Club",
    },
    {
      month: "Apr",
      income: 340,
      expense: 120,
      net: 220,
      topClub: "BOUN Debate Club",
    },
    {
      month: "May",
      income: 260,
      expense: 90,
      net: 170,
      topClub: "BOUN Astronomy Club",
    },
    {
      month: "Jun",
      income: 180,
      expense: 65,
      net: 115,
      topClub: "BOUN Film Club",
    },
    {
      month: "Jul",
      income: 120,
      expense: 45,
      net: 75,
      topClub: "BOUN Debate Club",
    },
    {
      month: "Aug",
      income: 100,
      expense: 38,
      net: 62,
      topClub: "BOUN Astronomy Club",
    },
    {
      month: "Sep",
      income: 240,
      expense: 85,
      net: 155,
      topClub: "BOUN Entrepreneurship Club",
    },
    {
      month: "Oct",
      income: 310,
      expense: 110,
      net: 200,
      topClub: "BOUN Debate Club",
    },
    {
      month: "Nov",
      income: 380,
      expense: 135,
      net: 245,
      topClub: "BOUN Entrepreneurship Club",
    },
    {
      month: "Dec",
      income: 290,
      expense: 100,
      net: 190,
      topClub: "BOUN Astronomy Club",
    },
  ],
  3: [
    {
      month: "Jan",
      income: 850,
      expense: 250,
      net: 600,
      topClub: "METU Hiking Club",
    },
    {
      month: "Feb",
      income: 925,
      expense: 290,
      net: 635,
      topClub: "METU AI & ML Club",
    },
    {
      month: "Mar",
      income: 1100,
      expense: 320,
      net: 780,
      topClub: "METU Music Club",
    },
    {
      month: "Apr",
      income: 1250,
      expense: 380,
      net: 870,
      topClub: "METU Hiking Club",
    },
    {
      month: "May",
      income: 980,
      expense: 310,
      net: 670,
      topClub: "METU AI & ML Club",
    },
    {
      month: "Jun",
      income: 600,
      expense: 190,
      net: 410,
      topClub: "METU Sustainability Club",
    },
    {
      month: "Jul",
      income: 400,
      expense: 130,
      net: 270,
      topClub: "METU Hiking Club",
    },
    {
      month: "Aug",
      income: 320,
      expense: 100,
      net: 220,
      topClub: "METU AI & ML Club",
    },
    {
      month: "Sep",
      income: 780,
      expense: 240,
      net: 540,
      topClub: "METU Music Club",
    },
    {
      month: "Oct",
      income: 1050,
      expense: 320,
      net: 730,
      topClub: "METU Hiking Club",
    },
    {
      month: "Nov",
      income: 1380,
      expense: 420,
      net: 960,
      topClub: "METU AI & ML Club",
    },
    {
      month: "Dec",
      income: 1100,
      expense: 350,
      net: 750,
      topClub: "METU Music Club",
    },
  ],
  4: [
    {
      month: "Jan",
      income: 330,
      expense: 120,
      net: 210,
      topClub: "MEU Robotics Club",
    },
    {
      month: "Feb",
      income: 260,
      expense: 90,
      net: 170,
      topClub: "MEU Photography Club",
    },
    {
      month: "Mar",
      income: 480,
      expense: 150,
      net: 330,
      topClub: "MEU Architecture Society",
    },
    {
      month: "Apr",
      income: 390,
      expense: 110,
      net: 280,
      topClub: "MEU Robotics Club",
    },
    {
      month: "May",
      income: 310,
      expense: 100,
      net: 210,
      topClub: "MEU Chess Club",
    },
    {
      month: "Jun",
      income: 200,
      expense: 70,
      net: 130,
      topClub: "MEU Photography Club",
    },
    {
      month: "Jul",
      income: 150,
      expense: 50,
      net: 100,
      topClub: "MEU Robotics Club",
    },
    {
      month: "Aug",
      income: 120,
      expense: 40,
      net: 80,
      topClub: "MEU Photography Club",
    },
    {
      month: "Sep",
      income: 280,
      expense: 90,
      net: 190,
      topClub: "MEU Architecture Society",
    },
    {
      month: "Oct",
      income: 420,
      expense: 140,
      net: 280,
      topClub: "MEU Robotics Club",
    },
    {
      month: "Nov",
      income: 500,
      expense: 180,
      net: 320,
      topClub: "MEU Chess Club",
    },
    {
      month: "Dec",
      income: 360,
      expense: 120,
      net: 240,
      topClub: "MEU Photography Club",
    },
  ],
};

export const MOCK_ACTIVITY_LOGS = [
  {
    id: 1,
    timestamp: "2026-03-05T09:15:00Z",
    universityId: 1,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Zeynep Çelik",
    actionType: "UPDATE_UNIVERSITY",
    targetType: "UNIVERSITY",
    targetId: 1,
    targetName: "Istanbul Technical University",
    targetNameLocal: "İstanbul Teknik Üniversitesi",
    messageEn:
      "Zeynep Çelik updated university profile information for Istanbul Technical University.",
    messageTr:
      "Zeynep Çelik, İstanbul Teknik Üniversitesi profil bilgilerini güncelledi.",
    metadata: { section: "contact" },
  },
  {
    id: 2,
    timestamp: "2026-03-05T11:40:00Z",
    universityId: 1,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Zeynep Çelik",
    actionType: "APPROVE_EVENT",
    targetType: "EVENT",
    targetId: 2,
    targetName: "Spring Chess Tournament",
    targetNameLocal: "Bahar Satranç Turnuvası",
    messageEn: "Zeynep Çelik approved event Spring Chess Tournament.",
    messageTr: "Zeynep Çelik, Bahar Satranç Turnuvası etkinliğini onayladı.",
    metadata: { clubName: "ITU Chess Club" },
  },
  {
    id: 3,
    timestamp: "2026-03-04T15:10:00Z",
    universityId: 1,
    actorRole: "ADVISOR",
    actorName: "Prof. Dr. Hasan Öztürk",
    actionType: "UPDATE_CLUB",
    targetType: "CLUB",
    targetId: 1,
    targetName: "ITU Robotics Club",
    targetNameLocal: "İTÜ Robotik Kulübü",
    messageEn:
      "Prof. Dr. Hasan Öztürk updated club profile for ITU Robotics Club.",
    messageTr:
      "Prof. Dr. Hasan Öztürk, İTÜ Robotik Kulübü profilini güncelledi.",
  },
  {
    id: 4,
    timestamp: "2026-03-03T08:20:00Z",
    universityId: 2,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Murat Aydın",
    actionType: "REJECT_EVENT",
    targetType: "EVENT",
    targetId: 11,
    targetName: "Film Screening Night",
    targetNameLocal: "Film Gösterim Gecesi",
    messageEn:
      "Murat Aydın rejected event Film Screening Night due to venue conflict.",
    messageTr:
      "Murat Aydın, Film Gösterim Gecesi etkinliğini mekan çakışması nedeniyle reddetti.",
  },
  {
    id: 5,
    timestamp: "2026-03-02T10:45:00Z",
    universityId: 2,
    actorRole: "CLUB_ADMIN",
    actorName: "Burak Şahin",
    actionType: "CREATE_EVENT",
    targetType: "EVENT",
    targetId: 9,
    targetName: "Startup Pitch Day",
    targetNameLocal: "Girişim Sunum Günü",
    messageEn: "Burak Şahin created a new event Startup Pitch Day.",
    messageTr:
      "Burak Şahin, Girişim Sunum Günü adlı yeni bir etkinlik oluşturdu.",
  },
  {
    id: 6,
    timestamp: "2026-03-01T14:00:00Z",
    universityId: 3,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Emre Koç",
    actionType: "UPDATE_AUTHORITY",
    targetType: "AUTHORITY",
    targetId: "7-9",
    targetName: "Bora Sen / METU AI & ML Club",
    targetNameLocal: "Bora Şen / ODTÜ YZ & ML Kulübü",
    messageEn:
      "Emre Koç updated authority settings for Bora Sen in METU AI & ML Club.",
    messageTr:
      "Emre Koç, Bora Şen için ODTÜ YZ & ML Kulübü yetki ayarlarını güncelledi.",
  },
  {
    id: 7,
    timestamp: "2026-02-28T12:30:00Z",
    universityId: 3,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Emre Koç",
    actionType: "CREATE_CAMPUS",
    targetType: "CAMPUS",
    targetId: 6,
    targetName: "Cultural Campus",
    targetNameLocal: "Kültür Kampüsü",
    messageEn: "Emre Koç created campus Cultural Campus.",
    messageTr: "Emre Koç, Kültür Kampüsü'nü oluşturdu.",
  },
  {
    id: 8,
    timestamp: "2026-02-27T16:05:00Z",
    universityId: 3,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Emre Koç",
    actionType: "UPDATE_DEPARTMENT",
    targetType: "DEPARTMENT",
    targetId: 10,
    targetName: "Industrial Engineering",
    targetNameLocal: "Endüstri Mühendisliği",
    messageEn:
      "Emre Koç updated department information for Industrial Engineering.",
    messageTr: "Emre Koç, Endüstri Mühendisliği bölüm bilgilerini güncelledi.",
  },
  {
    id: 9,
    timestamp: "2026-02-26T13:10:00Z",
    universityId: 2,
    actorRole: "SUPER_ADMIN",
    actorName: "Kerem Demir",
    actionType: "CREATE_FACULTY",
    targetType: "FACULTY",
    targetId: 6,
    targetName: "Faculty of Arts and Sciences",
    targetNameLocal: "Fen-Edebiyat Fakültesi",
    messageEn: "Kerem Demir created faculty Faculty of Arts and Sciences.",
    messageTr: "Kerem Demir, Fen-Edebiyat Fakültesi'ni oluşturdu.",
  },
  {
    id: 10,
    timestamp: "2026-02-25T09:55:00Z",
    universityId: 1,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Zeynep Çelik",
    actionType: "ADD_CLUB_MEMBER",
    targetType: "CLUB",
    targetId: 4,
    targetName: "ITU Photography Club",
    targetNameLocal: "İTÜ Fotoğrafçılık Kulübü",
    messageEn: "Zeynep Çelik added a new member to ITU Photography Club.",
    messageTr: "Zeynep Çelik, İTÜ Fotoğrafçılık Kulübü'ne yeni bir üye ekledi.",
  },
  {
    id: 11,
    timestamp: "2026-02-24T10:35:00Z",
    universityId: 1,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Zeynep Çelik",
    actionType: "DELETE_EVENT",
    targetType: "EVENT",
    targetId: 101,
    targetName: "Legacy Tech Meetup",
    targetNameLocal: "Eski Teknoloji Buluşması",
    messageEn: "Zeynep Çelik deleted event Legacy Tech Meetup.",
    messageTr: "Zeynep Çelik, Eski Teknoloji Buluşması etkinliğini sildi.",
  },
  {
    id: 12,
    timestamp: "2026-02-23T17:25:00Z",
    universityId: 2,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Murat Aydın",
    actionType: "DELETE_AUTHORITY",
    targetType: "AUTHORITY",
    targetId: "4-5",
    targetName: "Deniz Demir / BOUN Debate Club",
    targetNameLocal: "Deniz Demir / BOUN Münazara Kulübü",
    messageEn:
      "Murat Aydın removed authority assignment for Deniz Demir in BOUN Debate Club.",
    messageTr:
      "Murat Aydın, Deniz Demir için BOUN Münazara Kulübü yetki atamasını kaldırdı.",
  },
  {
    id: 13,
    timestamp: "2026-03-05T12:05:00Z",
    universityId: 4,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Selin Yıldız",
    actionType: "UPDATE_UNIVERSITY",
    targetType: "UNIVERSITY",
    targetId: 4,
    targetName: "Mersin University",
    targetNameLocal: "Mersin Üniversitesi",
    messageEn:
      "Selin Yıldız updated university profile information for Mersin University.",
    messageTr:
      "Selin Yıldız, Mersin Üniversitesi profil bilgilerini güncelledi.",
    metadata: { section: "contact" },
  },
  {
    id: 14,
    timestamp: "2026-03-05T14:30:00Z",
    universityId: 4,
    actorRole: "UNIVERSITY_MANAGER",
    actorName: "Selin Yıldız",
    actionType: "APPROVE_EVENT",
    targetType: "EVENT",
    targetId: 22,
    targetName: "Spring Chess Tournament",
    targetNameLocal: "Bahar Satranç Turnuvası",
    messageEn: "Selin Yıldız approved event Spring Chess Tournament.",
    messageTr: "Selin Yıldız, Bahar Satranç Turnuvası etkinliğini onayladı.",
    metadata: { clubName: "MEU Chess Club" },
  },
  {
    id: 15,
    timestamp: "2026-03-04T16:20:00Z",
    universityId: 4,
    actorRole: "ADVISOR",
    actorName: "Prof. Dr. Ayşe Kara",
    actionType: "UPDATE_CLUB",
    targetType: "CLUB",
    targetId: 13,
    targetName: "MEU Robotics Club",
    targetNameLocal: "MEU Robotik Kulübü",
    messageEn:
      "Prof. Dr. Ayşe Kara updated club profile for MEU Robotics Club.",
    messageTr: "Prof. Dr. Ayşe Kara, MEU Robotik Kulübü profilini güncelledi.",
  },
];

export const MOCK_USERS_UM = [
  {
    id: 1,
    universityId: 1,
    fullName: "Ahmet Yildiz",
    email: "ahmet.yildiz@itu.edu.tr",
    studentNumber: "ITU2026001",
    active: true,
  },
  {
    id: 2,
    universityId: 1,
    fullName: "Elif Acar",
    email: "elif.acar@itu.edu.tr",
    studentNumber: "ITU2026002",
    active: true,
  },
  {
    id: 3,
    universityId: 1,
    fullName: "Mert Kaya",
    email: "mert.kaya@itu.edu.tr",
    studentNumber: "ITU2026003",
    active: true,
  },
  {
    id: 4,
    universityId: 2,
    fullName: "Deniz Demir",
    email: "deniz.demir@boun.edu.tr",
    studentNumber: "BOUN2026001",
    active: true,
  },
  {
    id: 5,
    universityId: 2,
    fullName: "Sena Arslan",
    email: "sena.arslan@boun.edu.tr",
    studentNumber: "BOUN2026002",
    active: true,
  },
  {
    id: 6,
    universityId: 2,
    fullName: "Can Koc",
    email: "can.koc@boun.edu.tr",
    studentNumber: "BOUN2026003",
    active: true,
  },
  {
    id: 7,
    universityId: 3,
    fullName: "Bora Sen",
    email: "bora.sen@metu.edu.tr",
    studentNumber: "METU2026001",
    active: true,
  },
  {
    id: 8,
    universityId: 3,
    fullName: "Ceren Oz",
    email: "ceren.oz@metu.edu.tr",
    studentNumber: "METU2026002",
    active: true,
  },
  {
    id: 9,
    universityId: 3,
    fullName: "Yagiz Aydin",
    email: "yagiz.aydin@metu.edu.tr",
    studentNumber: "METU2026003",
    active: true,
  },
  {
    id: 10,
    universityId: 4,
    fullName: "Ahmet Yildiz",
    email: "ahmet.yildiz@MEU.edu.tr",
    studentNumber: "MEU2026001",
    active: true,
  },
  {
    id: 11,
    universityId: 4,
    fullName: "Elif Acar",
    email: "elif.acar@MEU.edu.tr",
    studentNumber: "MEU2026002",
    active: true,
  },
  {
    id: 12,
    universityId: 4,
    fullName: "Mert Kaya",
    email: "mert.kaya@MEU.edu.tr",
    studentNumber: "MEU2026003",
    active: true,
  },
];

export const MOCK_CLUB_MEMBERSHIPS = [
  { clubId: 1, userId: 1, role: "ADMIN", joinedAt: "2025-10-02T10:00:00" },
  { clubId: 1, userId: 2, role: "MODERATOR", joinedAt: "2025-10-03T10:00:00" },
  { clubId: 2, userId: 3, role: "MEMBER", joinedAt: "2025-10-05T10:00:00" },
  { clubId: 5, userId: 4, role: "ADMIN", joinedAt: "2025-10-10T10:00:00" },
  { clubId: 6, userId: 5, role: "MEMBER", joinedAt: "2025-10-12T10:00:00" },
  { clubId: 8, userId: 6, role: "MODERATOR", joinedAt: "2025-10-15T10:00:00" },
  { clubId: 9, userId: 7, role: "ADMIN", joinedAt: "2025-10-20T10:00:00" },
  { clubId: 10, userId: 8, role: "MEMBER", joinedAt: "2025-10-23T10:00:00" },
  { clubId: 12, userId: 9, role: "MODERATOR", joinedAt: "2025-10-26T10:00:00" },
  { clubId: 13, userId: 10, role: "ADMIN", joinedAt: "2025-10-27T10:00:00" },
  {
    clubId: 14,
    userId: 11,
    role: "MODERATOR",
    joinedAt: "2025-10-28T10:00:00",
  },
  { clubId: 16, userId: 12, role: "MEMBER", joinedAt: "2025-10-29T10:00:00" },
];
